import { NavLink } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

export default function NavBar() {
  const { theme } = useTheme();

  const linkStyle = (isActive: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    borderRadius: '8px',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
    background: isActive ? `${theme.colors.brand}15` : 'transparent',
    color: isActive ? theme.colors.brand : theme.colors.textSecondary,
    borderLeft: isActive ? `3px solid ${theme.colors.brand}` : '3px solid transparent',
  });

  return (
    <nav style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <NavLink to="/" style={({ isActive }) => linkStyle(isActive)} end>
        <span style={{ fontSize: '20px' }}>🏠</span>
        <span>Home</span>
      </NavLink>

      <NavLink to="/library" style={({ isActive }) => linkStyle(isActive)}>
        <span style={{ fontSize: '20px' }}>📚</span>
        <span>Library</span>
      </NavLink>

      <NavLink to="/uploads" style={({ isActive }) => linkStyle(isActive)}>
        <span style={{ fontSize: '20px' }}>📤</span>
        <span>Uploads</span>
      </NavLink>

      <NavLink to="/trash" style={({ isActive }) => linkStyle(isActive)}>
        <span style={{ fontSize: '20px' }}>🗑️</span>
        <span>Trash</span>
      </NavLink>

      <NavLink to="/settings" style={({ isActive }) => linkStyle(isActive)}>
        <span style={{ fontSize: '20px' }}>⚙️</span>
        <span>Settings</span>
      </NavLink>

      <NavLink to="/contact" style={({ isActive }) => linkStyle(isActive)}>
        <span style={{ fontSize: '20px' }}>✉️</span>
        <span>Contact Us</span>
      </NavLink>
    </nav>
  );
}
